// extracted by mini-css-extract-plugin
module.exports = {"whiteButton":"button_whiteButton__tUCoY","blueButton":"button_blueButton__1tI8G","LongButton":"button_LongButton__208J6","headerStyle":"button_headerStyle__2PcK2"};